/* global chrome */
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';

import { authenticateUser, fetchSSOUrlFromEmail, invalidateSSO } from "actions/login.jsx";
import styles from './login.module.scss';

import paperfliteLogo from 'images/paperflite_logo.svg';
import loginBackground from 'images/login/loginBackground.svg';
import loginElement from 'images/login/loginElement.svg';
import { useHistory } from "react-router-dom";
import cx from 'classnames';
import _ from "lodash";
import AuthService from "services/auth.service";
import { logoutUser } from "actions/users";

import element1 from 'images/login/element1.svg';
import element2 from 'images/login/element2.svg';
import element3 from 'images/login/element3.svg';
import gradient from 'images/login/backgroundGradient.svg';

export default function LoginView() {

  const dispatch = useDispatch();
  const history = useHistory();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const signinWithPassword = useSelector(state => _.get(state, 'login.sso.signinWithPassword')) || false;
  const ssoUrl = useSelector(state => _.get(state, 'login.sso.item.url'));
  const authenticated = useSelector(state => _.get(state, 'login.authenticated'));
  const authenticating = useSelector(state => _.get(state, 'login.authenticating'));

  const authenticationError = useSelector(state => state.login.authenticationError);
  const logout = useSelector((state) => _.get(state, 'users.logout'));
  const account = useSelector((state) => _.get(state, 'users.account.item')) || {};

  useEffect(() => {
   // authenticated check is for login
    // isAuthenticated check is for token refreshed
    // logout is added to avoid redirect loop on logout
    // account size check is to ensure that user account is fetched before redirecting to home
    if((AuthService.isAuthenticated() || authenticated) && !logout && _.size(account) > 0){
       history.push('/paperflite-home');
    } 
    else if(logout && (!AuthService.isAuthenticated())){
      dispatch(logoutUser(true, false))
    }
  }, [])
  
  useEffect(() => {
    if (ssoUrl) {
      dispatch(invalidateSSO());
      var newWindow = window.open(ssoUrl, '_blank');

      if (newWindow.focus) {
        newWindow.focus();
      }
    }
  }, [ssoUrl]);

  useEffect(() => {
    if(!_.isEmpty(authenticationError)){
      setError(authenticationError);
    }
  }, [authenticationError]);

  useEffect(() => {
    if (authenticated) {
      window.parent.postMessage({
        type: "PAPERFLITE_AUTHENTICATION",
        refresh_token: AuthService.getRefreshToken(),
        access_token: AuthService.getAccessToken()
      }, '*');

      history.push('/paperflite-home');
    }
  }, [authenticated, history]);


  const handleLogin = () => {
    var isValid = validateEmail();
    if (!isValid) {
      if (signinWithPassword) {
        dispatch(authenticateUser(username, password));
      } else {
        dispatch(fetchSSOUrlFromEmail(username));
      }
    }
  }

  const validateEmail = () => {
    var email = username;

    if (!email || email.trim() == '') {
      setError("Enter a valid email id");
      return true;
    }
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(email)) {
      setError("Enter a valid email id");
      return true;
    }

    return false;
  }

  const handleKeyDown = (e) => {
    if(e.key === "Enter"){
      handleLogin();
    }
  }

  return (
    <div className={styles.loginPage}>
      <img alt="Paperflite Logo" className={styles.logo} src={paperfliteLogo} />
      <div className={styles.loginElementContainer}>
        <div className={styles.loginHeader}>
          <p className={styles.header}>Get access to all information and <br/> content from your hub </p>
          <p className={styles.subtext}>Now faster, easier and smarter.</p>
        </div>
        <input
          value={username}
          placeholder="Enter your username to login..."
          className={styles.inputField}
          onChange={(e) => {
            e.preventDefault();
            setUsername(e.target.value);
            setError('')
          }}
          onKeyDown={(e) => handleKeyDown(e)}
        />
        {signinWithPassword &&
          <input
            autoFocus={true}
            value={password}
            placeholder="Password"
            className={styles.inputField}
            type="password"
            onChange={(e) => {
              e.preventDefault();
              setPassword(e.target.value);
              setError('')
            }}
            onKeyDown={(e) => handleKeyDown(e)}
          />
        }
        
       {error && <p className={cx(styles.errorMessage,{
          [styles.error] : error
        })}>{error}</p>}
      </div>

      <Button
        type='submit'
        className={styles.loginButton}
        onClick={(e) => {
          e.preventDefault();
          handleLogin()
        }}
        disabled={authenticating}
      >
        <i className="paperflite-right-arrow"/>
        Continue
      </Button>

      <img src={element1} alt="element1" className={cx( styles.element1)} />
      <img src={element2} alt="element2" className={cx( styles.element2)} />
      <img src={element3} alt="element3" className={cx( styles.element3)} />
      <img src={gradient} alt="gradient" className={cx( styles.gradient)} />
    </div>
  )
}